import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { loadingFade } from '../../animacoes';
import * as moment from 'moment';
import Swal from 'sweetalert2';

import { AuthService } from '../services/auth.service';
import { VeiculoService } from '../services/veiculo.service';
import { ManutencaoService } from '../services/manutencao.service';

@Component({
  selector: 'app-intervencoes-veiculo',
  templateUrl: './intervencoes-veiculo.component.html',
  styleUrls: ['./intervencoes-veiculo.component.css'],
  animations: [loadingFade]
})
export class IntervencoesVeiculoComponent implements OnInit {

  public loading;

  public veiculo;
  public veiculo_placa = '';
  public usuario_id;
  private dataAtual = moment(new Date()).format("YYYY-MM-DD");


  public manutencoes = [];

  // paginacao
  public page = 1;
  public limit = 10;
  public count = 0;

  constructor(
    private authSvc: AuthService,
    private route: ActivatedRoute,
    private veiculoSvc: VeiculoService,
    private manutencaoSvc: ManutencaoService,
  ) { }

  ngOnInit() {
    this.usuario_id = this.authSvc.getUsuarioId();
    this.route.params.subscribe(params => {
      this.pegaVeiculo(params.id);
    });
  } 
  
  pegaVeiculo(veiculo_id) {
    this.loading = true;
    this.veiculoSvc.getVeiculo(veiculo_id).then((data: any) => {
      this.veiculo = data;
      this.veiculo_placa = data.veiculo_placa;
      this.pegaManutencoes(veiculo_id);
      this.loading = false;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaManutencoes(veiculo_id) {
    this.loading = true;
    this.manutencaoSvc.getManutencaoByVeiculo(veiculo_id).then((data: any) => {
      this.manutencoes = data;
      this.count = this.manutencoes.length;
      this.loading = false;
    }).catch((err) => {
      console.log(err);
    });
  }

  // Método utilizado para retornar classes css que variam de acordo com o nivel da intervencao
  nivel(kmAtual, kmPrevista, dataPrevista) {

    if (kmAtual > kmPrevista || this.dataAtual > dataPrevista) {
      return 'late';
    }
    else if (kmAtual >= (kmPrevista - 1000) || this.dataAtual >= moment(dataPrevista).subtract('15', 'days').format('YYYY-MM-DD')) {
      return 'near';
    }
    else {
      return 'onTime';
    }
  }

  diasRestantes(dataPrevista) {
    let oneDay = 86400 * 1000;
    let dataAtual = new Date(new Date().toISOString().substr(0, 10)).getTime();
    let dataFinal = new Date(dataPrevista).getTime();

    let result = (dataAtual - dataFinal) / (oneDay);
    result = (dataAtual > dataFinal ? + result : result);

    return result * -1;
  }

  kmRestantes(quilometragem_prevista) {
    let result = quilometragem_prevista - this.veiculo.quilometragem;
    return (result > 0 ? result : '0');
  }


  primPagina() {
    this.page = 1;
  }

  paginaAnt() {
    this.page = Math.max(this.page - 1, 1);
  }

  proxPagina() {
    this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
  }

  ultPagina() {
    this.page = Math.ceil(this.count / this.limit);
  }

  onChangeStatus(manutencao_id, event) {

    this.loading = true;
    let toSend = ({
      'manutencao_id': manutencao_id,
      'manutencao_peca_visualizado': event.srcElement.checked == true ? 'S' : 'N',
    });

    this.manutencaoSvc.editaManutencaoIntervencoes(toSend).then((data) => {
      console.log('resp', data);
      this.loading = false;
      Swal.fire({
        type: 'success',
        title: 'Status alterado com sucesso!'
      });
    }).catch(err => {
      console.log(err);
      this.loading = false;
      Swal.fire({
        type: 'error',
        title: 'Ops! Algo de errado aconteceu!',
        text: 'Tente novamente mais tarde.'
      });
    });
  }

}
